import { thunk } from "easy-peasy";
import {
  makeAuthorizedGetRequestToBackend,
  makeUrl,
} from "../helpers/backendApi";
import { message } from "antd";

export const thunks = (modelSliceName, getPatchPayload, getPostPayload) => ({
  handleFetchInitialData: thunk(
    async (actions, payload, { getState, dispatch, getStoreState }) => {
      const {
        INITIAL_DATA_ENDPOINT,
        INCLUDE_APP_MODE_IN_INITIALDATA_REQUEST,
        INCLUDE_ITIN_MODE_IN_INITIALDATA_REQUEST,
      } = getState();
      const miscState = getStoreState().misc;
      const resp = await makeAuthorizedGetRequestToBackend({
        url: makeUrl({
          endpoint: INITIAL_DATA_ENDPOINT,
          appMode: INCLUDE_APP_MODE_IN_INITIALDATA_REQUEST && miscState.appMode,
          itinMode:
            INCLUDE_ITIN_MODE_IN_INITIALDATA_REQUEST && miscState.itinMode,
        }),
      });
      actions.receiveInitialData(resp.data);
      actions.markInitialDataReceived();
    }
  ),
  maybeHandleFetchInitialData: thunk(
    async (actions, payload, { getState, dispatch }) => {
      const { initialDataLoading, initialDataReceived, NAME } = getState();
      if (!initialDataLoading && !initialDataReceived) {
        actions.markInitialDataLoading();
        try {
          if (!initialDataReceived) {
            await dispatch[NAME].handleFetchInitialData();
          }
        } catch (e) {
          message.config({
            top: 100,
            duration: 5,
            maxCount: 10,
          });
          if (payload && payload.verbose) {
            message.error(
              "Sorry - something went wrong. Try refreshing this page. If this message appears again, please email team@saxecap.com."
            );
          }
          throw e;
        } finally {
          actions.markInitialDataNotLoading();
        }
      }
    }
  ),
});
